import { render, staticRenderFns } from "./BaseLoadingSpinner.vue?vue&type=template&id=1d1a9a30&scoped=true&"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=1d1a9a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a9a30",
  null
  
)

export default component.exports